import { render, staticRenderFns } from "./DialogoConfirmacion.vue?vue&type=template&id=d196b606&lang=true"
import script from "./DialogoConfirmacion.vue?vue&type=script&lang=js"
export * from "./DialogoConfirmacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports